import React, { useContext, useState } from 'react'
import { dateCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from 'admin/component/CommonScreen'
import { verificationHourlyMWH } from '../../api/pgads'
import { DatePickerContext } from 'context'
import { UtilityUnitSelection, isValidYearRange } from 'core'
import { DatePicker, message } from 'antd'

const VerificationHourly = _ => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const [unitSelection, setUnitSelect] = useState([])
  const screenCriteria = (s, p, su, onChange) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '250px 400px',
          columnGap: '5px',
          width: '650px',
        }}
      >
        <DatePicker.RangePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDateRangePicker || []}
          onChange={d => {
            setSelectedDateRagePicker(d)
            onChange()
            // retrieve({ dates: d })
          }}
        />
        <UtilityUnitSelection
          utility={(unitSelection && unitSelection[0]) || undefined}
          unit={(unitSelection && unitSelection[1]) || undefined}
          onUnitChange={value => {
            setUnitSelect(value)
            onChange()
          }}
          casStyle={{ width: '100%' }}
        />
      </div>
    )
  }

  const withCriteria = _ => ({
    unit: unitSelection[1],
    start: selectedDateRangePicker[0],
    end: selectedDateRangePicker[1],
  })

  const beforeRetrieveValidation = ({ validYearRange }) => {
    if (unitSelection.length <= 0 || !unitSelection[1]) {
      message.warn('Please, Select Unit')
      return false
    }
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  return (
    <CommonScreen
      beforeRetrieveValidation={beforeRetrieveValidation}
      titleProps={{ minWidth: '250px' }}
      screenCriteria={screenCriteria}
      withUnitSelection={false}
      withCriteria={withCriteria}
      retrieveTask={verificationHourlyMWH}
      title="Verification Hourly MWH"
      exportTitle="Verification Hourly MWH"
      header={VerificationMwWkHeaders}
      isAdminScreen={false}
      autoRetrieve={false}
      // sortOptions={[{ ident: 'stationName', display: 'Station Name', sortOrder: 'asc' }]}
      widthOffset={50}
      insertComp={false}
      insertCompHeight={0}
      onInsertEvent={_ => _}
      allowInsert={false}
      withoutModify
      heightOffset={250}
    />
  )
}

export default VerificationHourly
const VerificationMwWkHeaders = [
  strCol({
    ident: 'pnodeid',
    display: 'Pnodeid',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  dateCol({
    ident: 'transdate',
    display: 'Transdate',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({ ident: 'mwh1', display: 'MWH 1', isFiltered: true }),
  numCol({ ident: 'mwh2', display: 'MWH 2', isFiltered: true }),
  numCol({ ident: 'mwh3', display: 'MWH 3', isFiltered: true }),
  numCol({ ident: 'mwh4', display: 'MWH 4', isFiltered: true }),
  numCol({ ident: 'mwh5', display: 'MWH 5', isFiltered: true }),
  numCol({ ident: 'mwh6', display: 'MWH 6', isFiltered: true }),
  numCol({ ident: 'mwh7', display: 'MWH 7', isFiltered: true }),
  numCol({ ident: 'mwh8', display: 'MWH 8', isFiltered: true }),
  numCol({ ident: 'mwh9', display: 'MWH 9', isFiltered: true }),
  numCol({ ident: 'mwh10', display: 'MWH 10', isFiltered: true }),
  numCol({ ident: 'mwh11', display: 'MWH 11', isFiltered: true }),
  numCol({ ident: 'mwh12', display: 'MWH 12', isFiltered: true }),
  numCol({ ident: 'mwh13', display: 'MWH 13', isFiltered: true }),
  numCol({ ident: 'mwh14', display: 'MWH 14', isFiltered: true }),
  numCol({ ident: 'mwh15', display: 'MWH 15', isFiltered: true }),
  numCol({ ident: 'mwh16', display: 'MWH 16', isFiltered: true }),
  numCol({ ident: 'mwh17', display: 'MWH 17', isFiltered: true }),
  numCol({ ident: 'mwh18', display: 'MWH 18', isFiltered: true }),
  numCol({ ident: 'mwh19', display: 'MWH 19', isFiltered: true }),
  numCol({ ident: 'mwh20', display: 'MWH 20', isFiltered: true }),
  numCol({ ident: 'mwh21', display: 'MWH 21', isFiltered: true }),
  numCol({ ident: 'mwh22', display: 'MWH 22', isFiltered: true }),
  numCol({ ident: 'mwh23', display: 'MWH 23', isFiltered: true }),
  numCol({ ident: 'mwh24', display: 'MWH 24', isFiltered: true }),
  numCol({ ident: 'mwh25', display: 'MWH 25', isFiltered: true }),
]
